import type { LayoutConfig, PlanServiceItem } from '@/utils/dealCalculations'

export const PROPOSAL_PRESENTATION_KEY = 'rocket-proposal-presentation'

export type ProposalValueSlide = {
  layout: LayoutConfig
  planName: string
  planDescription: string
  supportHoursLabel: string
  supportTierLines: string[]
  planTipo: string
  projectType?: string
  planValue: number
  isRecurring: boolean
  hidePricing: boolean
  priceCompareFrom?: number
  paymentDetails: string
  loyaltyDuration: string
  negotiationDeadlineLabel: string
  bonusText: string
  serviceGroups: [string, PlanServiceItem[]][]
}

export type ProposalPresentationSnapshot = {
  empresaNome: string
  value: ProposalValueSlide
}

export function saveProposalPresentation(snapshot: ProposalPresentationSnapshot) {
  localStorage.setItem(PROPOSAL_PRESENTATION_KEY, JSON.stringify(snapshot))
}

export function readProposalPresentation(): ProposalPresentationSnapshot | null {
  try {
    const raw = localStorage.getItem(PROPOSAL_PRESENTATION_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as ProposalPresentationSnapshot
    if (!parsed?.value?.layout || typeof parsed.value.planName !== 'string') return null
    if (!Array.isArray(parsed.value.serviceGroups)) return null
    return parsed
  } catch {
    return null
  }
}
